import * as types from './types'

export default {
  showMessage ({commit}, message) {
    commit(types.SHOW_MESSAGE, message)
  },
  hideMessage ({commit}, message) {
    commit(types.HIDE_MESSAGE, message)
  },
  // websocket对象
  setWebSocket ({ commit }, obj) {
    commit(types.SET_WEBSOCKET, obj)
  },
  // websocket传递参数
  webSocketSend ({ commit }, data) {
    commit(types.WEDSOCKET_SEND, data)
  },

  // 更新通知消息数据
  setMessagesData ({ commit }, data) {
    commit(types.MESSAGES_DATA, data)
  },
}



// WEBPACK FOOTER //
// ./src/vuex/modules/messages/actions.js